import React from 'react'
import forward from '../../assets/images/player/forward.png'

function SongForward() {
  
  function skipForwardSong() {
    let activeSong = document.getElementById(`player-source`)
    
    activeSong.currentTime = activeSong.currentTime + 5
  }
  
  return (
    <button id={`song-forward`} onClick={skipForwardSong} style={{maskImage: `url(${forward})`, WebkitMaskImage: `url(${forward})`}}>Forward</button>
  )
}

export default SongForward